import React, { ReactNode } from 'react';

interface PanelProps {
    children: ReactNode;
    className?: string;
}

const Panel: React.FC<PanelProps> = ({ children, className = '' }) => (
    <div
        className={`bg-white border border-gray-200 rounded-2xl p-4 shadow-sm ${className}`}
    >
        {children}
    </div>
);

export default Panel;
